/**
 * Filters undefined, null or empty strings from a list of comma separated items, joins them and returns a string
 * Returns null if 'classes' is empty
 * @param {object} classes - An arguments object
 */
export const setClassNames = (...classes) => {
	const classList = new Set(classes);
	return [...classList].filter(c => c).join(' ') || null;
};



// WEBPACK FOOTER //
// ./src/utilities/classes.js